import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const TennisTable = ({ rows, hidden, leftCol, middleCol, rightCol }) => {
  return (
    <TableContainer sx={{ p: 0 }} component={Paper}>
      <Table sx={{ borderCollapse: "collapse" }}>
        <TableBody>
          {rows.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {/* Left Column with Nested Rows */}
              <TableCell
                sx={{
                  width: "30%",
                  borderRight: "1px solid #ccc", // Vertical border
                  padding: 0, // Remove extra spacing
                }}
              >
                <Table size="small" sx={{ borderCollapse: "collapse" }}>
                  {!hidden && (
                    <TableHead sx={{ background: "#9fe871" }}>
                      <TableRow>
                        <TableCell
                          sx={{
                            padding: "8px",
                            borderBottom: "1px solid #ccc",
                          }}
                        >
                          <strong>{leftCol}</strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  )}
                  <TableBody>
                    {row.left.map((leftItem, leftIndex) => (
                      <TableRow key={`left-${rowIndex}-${leftIndex}`}>
                        <TableCell sx={{ padding: "8px" }}>
                          {leftItem}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableCell>

              {/* Right Column with Nested Rows and Headers */}
              <TableCell
                sx={{
                  width: "70%",
                  padding: 0, // Remove extra spacing
                }}
              >
                <Table size="small" sx={{ borderCollapse: "collapse" }}>
                  {!hidden && (
                    <TableHead sx={{ background: "#9fe871" }}>
                      <TableRow>
                        <TableCell
                          sx={{
                            width: "50%",
                            borderRight: "1px solid #ccc", // Vertical border
                            padding: "8px",
                            borderBottom: "1px solid #ccc",
                          }}
                        >
                          <strong>{middleCol}</strong>
                        </TableCell>
                        <TableCell
                          sx={{
                            width: "50%",
                            padding: "8px",
                            borderBottom: "1px solid #ccc",
                          }}
                        >
                          <strong>{rightCol}</strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  )}
                  <TableBody>
                    {row.right.map((rightItem, rightIndex) => (
                      <TableRow key={`right-${rowIndex}-${rightIndex}`}>
                        <TableCell
                          sx={{
                            width: "50%",
                            borderRight: "1px solid #ccc", // Vertical border
                            padding: "8px",
                          }}
                        >
                          {rightItem.column1}
                        </TableCell>
                        <TableCell sx={{ width: "50%", padding: "8px" }}>
                          {rightItem.column2}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TennisTable;
